module.exports = __webpack_public_path__ + "img/emil.474bc842.png";